import { Button } from "@material-ui/core";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import './MemecoinNew.css'
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Navigation, Pagination } from 'swiper/modules';
import { FiArrowUpRight } from "react-icons/fi";


function MemecoinNew() {
  return (
    <main>
      <NewHead />
      <Helmet>
        <title>
          Meme Coin Development Company | Create Viral Digital Assets
        </title>

        <meta
          name="title"
          content="Meme Coin Development Company | Create Viral Digital Assets"
        />
        <meta
          name="description"
          content=" Beleaf technologies is a top meme coin development company offering end to end meme coin development service at premium quality. Get a free demo from our experts and start developing your dream meme coin like shiba."
        />

        <meta property="og:title" content="Meme Coin Development Company" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/meme-coin-development-company"
        />
      </Helmet>
      <main className="memcoin_main_new">
        {/* section 1 */}

        <article className='Memecoin_hero_sct Memecoin_commn_sct'>
          <div className='Memecoin_hero_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_hero_wrp'>
              <div className='Memecoin_hero_ContTop'>
                <h1>Meme coin development company</h1>
                <p>
                  If you’re looking to launch your own meme coin, you’ve come to the right place. As a leading meme coin development company, we specialize in creating innovative and successful meme coins tailored to your vision.
                </p>
                <button className='Memecoin_cmmn_Btn1'
                  data-toggle="modal"
                  data-target="#myModal"
                  aria-label="Get free consultation"
                >
                  <span className="MuiButton-label Memecoin_cmmn_Btn1Txt">Free demo</span>
                  <span className='Memecoin_cmmn_Btn1Arrw'>
                    <FiArrowUpRight className='Memecoin_cmmn_Btn1Arrw1' />
                    <FiArrowUpRight className='Memecoin_cmmn_Btn1Arrw2' />
                  </span>
                </button>
              </div>
              <div className='Memecoin_hero_rgt'>
                <img src={new URL("../../../image/MemecoinNew/Memecoin_hero_img.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_hero-img" />

              </div>

            </div>
          </div>
        </article>

        {/* section 2 */}

        <article className='Memecoin_wht_sct Memecoin_commn_sct'>
          <div className='Memecoin_wht_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_wht_wrp'>
              <div className='Memecoin_wht_lft'>
                <h2 className='Memecoin_common_title'>What is Meme Coin</h2>
                <p className='Memecoin_common_desp'>
                  Meme coins are cryptocurrencies inspired by internet memes, cultural references, or popular trends. Unlike traditional cryptocurrencies like Bitcoin or Ethereum, meme coins often leverage humor, pop culture, and community-driven narratives to build their unique
                  identity. Examples like Dogecoin and Shiba Inu have shown that meme coins can achieve tremendous success by combining fun and functionality. As a Meme Coin Development Company, we specialize in creating unique, engaging, and technically
                  sound meme coins that stand out in the competitive crypto market.
                </p>
                <button className='Memecoin_cmmn_Btn2'
                  data-toggle="modal"
                  data-target="#myModal"
                  aria-label="Get free consultation"
                >
                  <span className="MuiButton-label Memecoin_cmmn_Btn2Txt">Talk to an expert</span>
                  <span className='Memecoin_cmmn_Btn2Arrw'>
                    <FiArrowUpRight className='Memecoin_cmmn_Btn2Arrw1' />
                    <FiArrowUpRight className='Memecoin_cmmn_Btn2Arrw2' />
                  </span>
                </button>
              </div>
              <div className='Memecoin_wht_rgt'>
                <img src={new URL("../../../image/MemecoinNew/Memecoin_wht_img.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_wht-img" />

              </div>

            </div>
          </div>
        </article>

        {/* section 3 */}

        <article className='Memecoin_benefit_sct Memecoin_commn_sct'>
          <div className='Memecoin_benefit_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_benefit_wrp'>
              <div className='Memecoin_benefit_lft'>
                <h2 className='Memecoin_common_title Memecoin_benefit_title'>Benefits of Launching a Meme Coin</h2>
                <p className='Memecoin_common_desp'>
                  Partnering with a reputed meme coin development company opens up a world of opportunities.
                  Here are the key benefits:
                </p>

              </div>
              <div className='Memecoin_benefit_rgt'>
                <div className="Memecoin_benefit_LstItm Memecoin_benefit_lrgItm">
                  <div className="Memecoin_benefit_lftItm">
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_benefit_img1.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_benefit_img" />
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_benefit_hover_img1.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_benefit_hover_img" />

                  </div>
                  <div className="Memecoin_benefit_rgtItm">
                    <h3 className="Memecoin_benefit_lftItm_title">Community-Driven Growth</h3>
                    <p className="Memecoin_benefit_lftItm_para">Meme coins rely on passionate communities that drive adoption and value.</p>
                  </div>
                </div>
                <div className="Memecoin_benefit_LstItm Memecoin_benefit_smlItm">
                  <div className="Memecoin_benefit_lftItm">
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_benefit_img2.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_benefit_img" />
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_benefit_hover_img2.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_benefit_hover_img" />

                  </div>
                  <div className="Memecoin_benefit_rgtItm">
                    <h3 className="Memecoin_benefit_lftItm_title">Viral Potential</h3>
                    <p className="Memecoin_benefit_lftItm_para">Meme coins thrive on internet culture, making them highly shareable and viral.</p>
                  </div>
                </div>
                <div className="Memecoin_benefit_LstItm Memecoin_benefit_smlItm">
                  <div className="Memecoin_benefit_lftItm">
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_benefit_img3.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_benefit_img" />
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_benefit_hover_img3.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_benefit_hover_img" />

                  </div>
                  <div className="Memecoin_benefit_rgtItm">
                    <h3 className="Memecoin_benefit_lftItm_title">Innovation and Creativity</h3>
                    <p className="Memecoin_benefit_lftItm_para">Meme coins allow you to combine humor with cutting-edge blockchain technology.</p>
                  </div>
                </div>
                <div className="Memecoin_benefit_LstItm Memecoin_benefit_smlItm">
                  <div className="Memecoin_benefit_lftItm">
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_benefit_img4.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_benefit_img" />
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_benefit_hover_img4.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_benefit_hover_img" />

                  </div>
                  <div className="Memecoin_benefit_rgtItm">
                    <h3 className="Memecoin_benefit_lftItm_title">High ROI Potential</h3>
                    <p className="Memecoin_benefit_lftItm_para">With the right strategy, meme coins can deliver impressive returns on investment.</p>
                  </div>
                </div>
                <div className="Memecoin_benefit_LstItm Memecoin_benefit_smlItm">
                  <div className="Memecoin_benefit_lftItm">
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_benefit_img5.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_benefit_img" />
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_benefit_hover_img5.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_benefit_hover_img" />

                  </div>
                  <div className="Memecoin_benefit_rgtItm">
                    <h3 className="Memecoin_benefit_lftItm_title">Global Reach</h3>
                    <p className="Memecoin_benefit_lftItm_para">Cryptocurrency is a global phenomenon, offering limitless opportunities for growth.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </article>


        {/* section 4 */}

        <article className='Memecoin_why_sct Memecoin_commn_sct'>
          <img src={new URL("../../../image/MemecoinNew/Memecoin_why_side_Lft_img.webp", import.meta.url)} alt='meme-coin-development-company' className="Memecoin_why_side_img1" />
          <img src={new URL("../../../image/MemecoinNew/Memecoin_why_side_rgt_img.webp", import.meta.url)} alt='meme-coin-development-company' className="Memecoin_why_side_img2" />
          <div className='Memecoin_why_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_why_wrp'>
              <div className='Memecoin_why_lft'>
                <h2 className='Memecoin_common_title Memecoin_why_title'>Why Choose Us as Your Meme Coin Development Company?</h2>
                <p className='Memecoin_common_desp'>
                  At our meme coin development company, we combine technical expertise with creative thinking to bring your idea to life. Here’s why we stand out:
                </p>

              </div>
              <div className='Memecoin_why_rgt'>
                <div className="Memecoin_why_lstItm">
                  <img src={new URL("../../../image/MemecoinNew/Memecoin_why_img1.webp", import.meta.url)} alt='meme-coin-development-company' className="Memecoin_why_img" />
                  <div className="">
                    <h3 className="Memecoin_why_lstItm_title">Expert Blockchain Developers</h3>
                    <p className="Memecoin_why_lstItm_desp">Our team consists of highly skilled blockchain developers who excel in designing robust and scalable meme coins.</p>
                  </div>
                </div>
                <div className="Memecoin_why_lstItm">
                  <img src={new URL("../../../image/MemecoinNew/Memecoin_why_img2.webp", import.meta.url)} alt='meme-coin-development-company' className="Memecoin_why_img" />
                  <div className="">
                    <h3 className="Memecoin_why_lstItm_title">Custom Solutions</h3>
                    <p className="Memecoin_why_lstItm_desp">We offer customized solutions to meet your specific requirements and ensure your meme coin stands out.</p>
                  </div>
                </div>
                <div className="Memecoin_why_lstItm">
                  <img src={new URL("../../../image/MemecoinNew/Memecoin_why_img3.webp", import.meta.url)} alt='meme-coin-development-company' className="Memecoin_why_img" />
                  <div className="">
                    <h3 className="Memecoin_why_lstItm_title">Expert Blockchain Developers</h3>
                    <p className="Memecoin_why_lstItm_desp">From ideation to deployment, we provide end-to-end meme coin development services.</p>
                  </div>
                </div>
                <div className="Memecoin_why_lstItm">
                  <img src={new URL("../../../image/MemecoinNew/Memecoin_why_img4.webp", import.meta.url)} alt='meme-coin-development-company' className="Memecoin_why_img" />
                  <div className="">
                    <h3 className="Memecoin_why_lstItm_title"> Proven Track Record</h3>
                    <p className="Memecoin_why_lstItm_desp">Our successful portfolio speaks volumes about our capabilities as a meme coin development company.</p>
                  </div>
                </div>
                <div className="Memecoin_why_lstItm">
                  <img src={new URL("../../../image/MemecoinNew/Memecoin_why_img5.webp", import.meta.url)} alt='meme-coin-development-company' className="Memecoin_why_img" />
                  <div className="">
                    <h3 className="Memecoin_why_lstItm_title">Community Engagement</h3>
                    <p className="Memecoin_why_lstItm_desp">We understand the importance of building a strong community around your meme coin and offer strategies to ensure its growth.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </article>

        {/* section 5 */}

        <article className='Memecoin_our_sct Memecoin_commn_sct' >
          <div className='Memecoin_our_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_our_wrp'>

              <div className='Memecoin_our_lft'>
                <h2 className='Memecoin_common_title'>Our Meme Coin Development Services</h2>
                <p className='Memecoin_common_desp'>
                  As a top-tier meme coin development company, we offer a wide range of services to help you achieve your goals:
                </p>
                <button className='Memecoin_cmmn_Btn2'
                  data-toggle="modal"
                  data-target="#myModal"
                  aria-label="Get free consultation"
                >
                  <span className="MuiButton-label Memecoin_cmmn_Btn2Txt">Get quote</span>
                  <span className='Memecoin_cmmn_Btn2Arrw'>
                    <FiArrowUpRight className='Memecoin_cmmn_Btn2Arrw1' />
                    <FiArrowUpRight className='Memecoin_cmmn_Btn2Arrw2' />
                  </span>
                </button>
              </div>

              <div className="Memecoin_our_rgt">

                <Swiper navigation={true} pagination={true} modules={[Navigation, Pagination]} loop className="mySwiper Memecoin_swiper" breakpoints={{
                  576: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                  },
                  650: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                  1400: {
                    slidesPerView: 3.2,
                    spaceBetween: 32,
                  },
                }}>
                  <SwiperSlide>
                    <div className='Memecoin_ourswiper_wrp'>
                      <div className='Memecoin_ourswiper_lstItm'>
                        <div className="Memecoin_ourswiper_lst_lft">
                          <img className="Memecoin_our_imgBck" src={new URL("../../../image/MemecoinNew/Memecoin_our_imgBck.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                          <img className="Memecoin_our_img1" src={new URL("../../../image/MemecoinNew/Memecoin_our_img1.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                        </div>
                        <div className="Memecoin_ourswiper_lst_rgt">
                          <h3 className="Memecoin_ourswiper_lst_title">Meme Coin Ideation and Consultation</h3>
                          <p className="Memecoin_ourswiper_lst_desp">We help you refine your concept and identify key features for your meme coin.</p>
                          <p className="Memecoin_ourswiper_lst_desp">Market analysis to align your coin with current trends.</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className='Memecoin_ourswiper_wrp'>
                      <div className='Memecoin_ourswiper_lstItm'>
                        <div className="Memecoin_ourswiper_lst_lft">
                          <img className="Memecoin_our_imgBck" src={new URL("../../../image/MemecoinNew/Memecoin_our_imgBck.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                          <img className="Memecoin_our_img1" src={new URL("../../../image/MemecoinNew/Memecoin_our_img2.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                        </div>
                        <div className="Memecoin_ourswiper_lst_rgt">
                          <h3 className="Memecoin_ourswiper_lst_title">Blockchain Selection</h3>
                          <p className="Memecoin_ourswiper_lst_desp">Assistance in choosing the right blockchain, such as Ethereum, Binance Smart Chain, or Solana.</p>
                          <p className="Memecoin_ourswiper_lst_desp">Evaluation of transaction speed, scalability, and cost.</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className='Memecoin_ourswiper_wrp'>
                      <div className='Memecoin_ourswiper_lstItm'>
                        <div className="Memecoin_ourswiper_lst_lft">
                          <img className="Memecoin_our_imgBck" src={new URL("../../../image/MemecoinNew/Memecoin_our_imgBck.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                          <img className="Memecoin_our_img1" src={new URL("../../../image/MemecoinNew/Memecoin_our_img3.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                        </div>
                        <div className="Memecoin_ourswiper_lst_rgt">
                          <h3 className="Memecoin_ourswiper_lst_title">Smart Contract Development</h3>
                          <p className="Memecoin_ourswiper_lst_desp">Development of secure and efficient smart contracts to power your meme coin.</p>
                          <p className="Memecoin_ourswiper_lst_desp">Rigorous testing to eliminate vulnerabilities.</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className='Memecoin_ourswiper_wrp'>
                      <div className='Memecoin_ourswiper_lstItm'>
                        <div className="Memecoin_ourswiper_lst_lft">
                          <img className="Memecoin_our_imgBck" src={new URL("../../../image/MemecoinNew/Memecoin_our_imgBck.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                          <img className="Memecoin_our_img1" src={new URL("../../../image/MemecoinNew/Memecoin_our_img4.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                        </div>
                        <div className="Memecoin_ourswiper_lst_rgt">
                          <h3 className="Memecoin_ourswiper_lst_title">Tokenomics Design</h3>
                          <p className="Memecoin_ourswiper_lst_desp">Strategic planning of supply, distribution, and rewards.</p>
                          <p className="Memecoin_ourswiper_lst_desp">Implementation of burn mechanisms, staking, and liquidity pools.</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className='Memecoin_ourswiper_wrp'>
                      <div className='Memecoin_ourswiper_lstItm'>
                        <div className="Memecoin_ourswiper_lst_lft">
                          <img className="Memecoin_our_imgBck" src={new URL("../../../image/MemecoinNew/Memecoin_our_imgBck.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                          <img className="Memecoin_our_img1" src={new URL("../../../image/MemecoinNew/Memecoin_our_img5.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                        </div>
                        <div className="Memecoin_ourswiper_lst_rgt">
                          <h3 className="Memecoin_ourswiper_lst_title">Meme Coin Branding and Design</h3>
                          <p className="Memecoin_ourswiper_lst_desp">Creation of a compelling brand identity, including logo, mascot, and website.</p>
                          <p className="Memecoin_ourswiper_lst_desp">Engaging graphics and memes to resonate with your target audience.</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className='Memecoin_ourswiper_wrp'>
                      <div className='Memecoin_ourswiper_lstItm'>
                        <div className="Memecoin_ourswiper_lst_lft">
                          <img className="Memecoin_our_imgBck" src={new URL("../../../image/MemecoinNew/Memecoin_our_imgBck.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                          <img className="Memecoin_our_img1" src={new URL("../../../image/MemecoinNew/Memecoin_our_img6.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                        </div>
                        <div className="Memecoin_ourswiper_lst_rgt">
                          <h3 className="Memecoin_ourswiper_lst_title">Meme Coin Wallet Development</h3>
                          <p className="Memecoin_ourswiper_lst_desp">Design and development of user-friendly wallets compatible with your meme coin.</p>
                          <p className="Memecoin_ourswiper_lst_desp">Multi-platform support for seamless access.</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className='Memecoin_ourswiper_wrp'>
                      <div className='Memecoin_ourswiper_lstItm'>
                        <div className="Memecoin_ourswiper_lst_lft">
                          <img className="Memecoin_our_imgBck" src={new URL("../../../image/MemecoinNew/Memecoin_our_imgBck.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                          <img className="Memecoin_our_img1" src={new URL("../../../image/MemecoinNew/Memecoin_our_img7.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                        </div>
                        <div className="Memecoin_ourswiper_lst_rgt">
                          <h3 className="Memecoin_ourswiper_lst_title">Marketing and Community Building</h3>
                          <p className="Memecoin_ourswiper_lst_desp">Comprehensive marketing strategies, including social media, influencer outreach, and PR campaigns.</p>
                          <p className="Memecoin_ourswiper_lst_desp">Building and managing an active community to foster engagement.</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className='Memecoin_ourswiper_wrp'>
                      <div className='Memecoin_ourswiper_lstItm'>
                        <div className="Memecoin_ourswiper_lst_lft">
                          <img className="Memecoin_our_imgBck" src={new URL("../../../image/MemecoinNew/Memecoin_our_imgBck.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                          <img className="Memecoin_our_img1" src={new URL("../../../image/MemecoinNew/Memecoin_our_img8.webp", import.meta.url)} alt='crypto-smart-order-routing-services' />
                        </div>
                        <div className="Memecoin_ourswiper_lst_rgt">
                          <h3 className="Memecoin_ourswiper_lst_title">Listing on Cryptocurrency Exchanges</h3>
                          <p className="Memecoin_ourswiper_lst_desp">Assistance with listing your meme coin on top cryptocurrency exchanges.</p>
                          <p className="Memecoin_ourswiper_lst_desp">Ensuring liquidity and visibility for your token.</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>

            </div>
          </div>
        </article>

        {/* section 6 */}

        <article className='Memecoin_tech_sct Memecoin_commn_sct'>
          <div className='Memecoin_tech_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_tech_wrp'>
              <div className='Memecoin_tech_lft'>
                <h2 className='Memecoin_common_title Memecoin_tech_title'>Technologies We Use for Meme Coin Development</h2>
                <p className='Memecoin_common_desp Memecoin_common_desp1'>
                  As a leading meme coin development company, we leverage advanced technologies to deliver exceptional results
                </p>

              </div>
              <div className='Memecoin_tech_rgt'>
                <div className="Memecoin_tech_rgt_Lst">
                  <h3 className="Memecoin_tech_rgt_title">Blockchain Platforms</h3>
                  <img src={new URL("../../../image/MemecoinNew/Memecoin_tech_img1.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_tech_rgt_img" />
                  <img src={new URL("../../../image/MemecoinNew/Memecoin_tech_hover_img1.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_tech_rgt_hover_img" />


                </div>
                <div className="Memecoin_tech_rgt_Lst">
                  <h3 className="Memecoin_tech_rgt_title">Programming Languages</h3>
                  <img src={new URL("../../../image/MemecoinNew/Memecoin_tech_img2.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_tech_rgt_img" />
                  <img src={new URL("../../../image/MemecoinNew/Memecoin_tech_hover_img2.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_tech_rgt_hover_img" />

                </div>
                <div className="Memecoin_tech_rgt_Lst">
                  <h3 className="Memecoin_tech_rgt_title">Security Protocols</h3>
                  <img src={new URL("../../../image/MemecoinNew/Memecoin_tech_img3.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_tech_rgt_img" />
                  <img src={new URL("../../../image/MemecoinNew/Memecoin_tech_hover_img3.webp", import.meta.url)} alt='crypto-smart-order-routing-services' className="Memecoin_tech_rgt_hover_img" />

                </div>
              </div>

            </div>
          </div>
        </article>

        {/* Future of Meme Coin Development */}

        <article className='Memecoin_fuctr_sct Memecoin_commn_sct'>
          <div className='Memecoin_fuctr_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_fuctr_wrp'>
              <div className='Memecoin_fuctr_lft'>
                <h2 className='Memecoin_common_title'>Future of Meme Coin Development</h2>
                <p className='Memecoin_common_desp'>
                  The future of meme coin development looks promising as these tokens continue to
                  evolve from mere jokes to viable financial instruments.
                  Here are some trends and possibilities shaping the future
                </p>
              </div>

              <Swiper navigation={true} pagination={true} modules={[Navigation, Pagination]} loop className="mySwiper Memecoin_fuctr_swiper" breakpoints={{
                576: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                650: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                1400: {
                  slidesPerView: 4.2,
                  spaceBetween: 30,
                },
              }}>
                <SwiperSlide>
                  <div className='Memecoin_fuctr_itm'>
                    <div className='Memecoin_fuctr_itmImg'>
                      <div className="Memecoin_fuctr_itmImgInsd">
                        <img src={new URL("../../../image/MemecoinNew/Memecoin_fuctr_itmImg1.webp", import.meta.url)} alt='' />
                      </div>
                    </div>
                    <div className='Memecoin_fuctr_itmCnt'>
                      <h3>Increased Utility</h3>
                      <p>
                        Meme coins are moving beyond humor and embracing real-world
                        use cases such as payments,
                        DeFi integration, and gaming. Developers are exploring innovative
                        ways to add value to these coins.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='Memecoin_fuctr_itm'>
                    <div className='Memecoin_fuctr_itmImg'>
                      <div className="Memecoin_fuctr_itmImgInsd">
                        <img src={new URL("../../../image/MemecoinNew/Memecoin_fuctr_itmImg2.webp", import.meta.url)} alt='' />
                      </div>
                    </div>
                    <div className='Memecoin_fuctr_itmCnt'>
                      <h3>Stronger Communities</h3>
                      <p>
                        As meme coins rely heavily on community support, future projects will likely
                        focus more on building robust and engaged communities. Decentralized autonomous
                        organizations (DAOs) are expected to play a bigger role in governance.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='Memecoin_fuctr_itm'>
                    <div className='Memecoin_fuctr_itmImg'>
                      <div className="Memecoin_fuctr_itmImgInsd">
                        <img src={new URL("../../../image/MemecoinNew/Memecoin_fuctr_itmImg3.webp", import.meta.url)} alt='' />
                      </div>
                    </div>
                    <div className='Memecoin_fuctr_itmCnt'>
                      <h3>Integration with NFTs</h3>
                      <p>
                        Meme coins are increasingly being linked with non-fungible tokens (NFTs), creating
                        exciting opportunities for collectors and investors. This trend is expected to grow,
                        offering unique digital assets tied to meme coins.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='Memecoin_fuctr_itm'>
                    <div className='Memecoin_fuctr_itmImg'>
                      <div className="Memecoin_fuctr_itmImgInsd">
                        <img src={new URL("../../../image/MemecoinNew/Memecoin_fuctr_itmImg4.webp", import.meta.url)} alt='' />
                      </div>
                    </div>
                    <div className='Memecoin_fuctr_itmCnt'>
                      <h3>Sustainability Initiatives</h3>
                      <p>
                        With growing environmental concerns, future meme coins may adopt eco-friendly
                        blockchain platforms and sustainable practices to attract conscious investors.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='Memecoin_fuctr_itm'>
                    <div className='Memecoin_fuctr_itmImg'>
                      <div className="Memecoin_fuctr_itmImgInsd">
                        <img src={new URL("../../../image/MemecoinNew/Memecoin_fuctr_itmImg5.webp", import.meta.url)} alt='' />
                      </div>
                    </div>
                    <div className='Memecoin_fuctr_itmCnt'>
                      <h3>Enhanced Security</h3>
                      <p>
                        As the meme coin space matures,. Advanced technologies like AI and machine
                        learning will be employed to safeguard meme coin projects.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='Memecoin_fuctr_itm'>
                    <div className='Memecoin_fuctr_itmImg'>
                      <div className="Memecoin_fuctr_itmImgInsd">
                        <img src={new URL("../../../image/MemecoinNew/Memecoin_fuctr_itmImg6.webp", import.meta.url)} alt='' />
                      </div>
                    </div>
                    <div className='Memecoin_fuctr_itmCnt'>
                      <h3>Institutional Interest</h3>
                      <p>
                        The success of popular meme coins has caught the attention of institutional investors.
                        Future projects might see greater backing from major players, increasing credibility and adoption.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='Memecoin_fuctr_itm'>
                    <div className='Memecoin_fuctr_itmImg'>
                      <div className="Memecoin_fuctr_itmImgInsd">
                        <img src={new URL("../../../image/MemecoinNew/Memecoin_fuctr_itmImg7.webp", import.meta.url)} alt='' />
                      </div>
                    </div>
                    <div className='Memecoin_fuctr_itmCnt'>
                      <h3>Regulatory Clarity</h3>
                      <p>
                        As governments worldwide provide clearer guidelines on cryptocurrencies,
                        meme coin development will become more streamlined and compliant,
                        encouraging broader participation.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>

              </Swiper>

              {/* <div className='Memecoin_fuctr_lst'>
                                <div className='Memecoin_fuctr_itm'>
                                    <div className='Memecoin_fuctr_itmImg'>
                                          <div className="Memecoin_fuctr_itmImgInsd">
                                            <img />
                                          </div>
                                    </div>
                                    <div className='Memecoin_fuctr_itmCnt'>
                                        <h3>Increased Utility</h3>
                                        <p>
                                            Meme coins are moving beyond humor and embracing real-world 
                                            use cases such as payments, 
                                            DeFi integration, and gaming. Developers are exploring innovative 
                                            ways to add value to these coins.
                                        </p>
                                    </div>
                                </div>
                            </div> */}

            </div>

          </div>
        </article>

        {/* Why Meme Coins Are Here to Stay */}

        <article className='Memecoin_whymeme_sct Memecoin_commn_sct'>
          <div className='Memecoin_whymeme_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_whymeme_wrp'>
              <div className='Memecoin_whymeme_rgt'>
                <img src={new URL("../../../image/MemecoinNew/Memecoin_why_itmImg1.webp", import.meta.url)} alt='' />
              </div>
              <div className='Memecoin_whymeme_lft'>
                <h2 className='Memecoin_common_title'>Why Meme Coins Are Here to Stay</h2>
                <p className='Memecoin_common_desp'>
                  Meme coins have demonstrated remarkable resilience and adaptability in the crypto market.
                  Their ability to engage communities and leverage humor ensures their continued relevance.
                  By partnering with a leading meme coin development company, you can harness this potential
                  to create a thriving crypto project.
                </p>
                <button className='Memecoin_cmmn_Btn2'
                  data-toggle="modal"
                  data-target="#myModal"
                  aria-label="Get free consultation"
                >
                  <span className="MuiButton-label Memecoin_cmmn_Btn2Txt">Contact us</span>
                  <span className='Memecoin_cmmn_Btn2Arrw'>
                    <FiArrowUpRight className='Memecoin_cmmn_Btn2Arrw1' />
                    <FiArrowUpRight className='Memecoin_cmmn_Btn2Arrw2' />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* Steps to Launch Your Meme Coin */}

        <article className='Memecoin_steps_sct Memecoin_commn_sct'>
          <div className='Memecoin_steps_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_steps_wrp'>
              <div className='Memecoin_steps_lft'>
                <h2 className='Memecoin_common_title'>Steps to Launch Your Meme Coin</h2>
                <p className='Memecoin_common_desp'>
                  As a professional meme coin development company, we follow a streamlined process to ensure success:
                </p>
                <button className='Memecoin_cmmn_Btn2'
                  data-toggle="modal"
                  data-target="#myModal"
                  aria-label="Get free consultation"
                >
                  <span className="MuiButton-label Memecoin_cmmn_Btn2Txt">Free demo</span>
                  <span className='Memecoin_cmmn_Btn2Arrw'>
                    <FiArrowUpRight className='Memecoin_cmmn_Btn2Arrw1' />
                    <FiArrowUpRight className='Memecoin_cmmn_Btn2Arrw2' />
                  </span>
                </button>
              </div>
              <div className='Memecoin_steps_rgt'>
                <ul className="Memecoin_steps_rgtLst">
                  <li
                    className={`Memecoin_steps_rgtItm`}
                  >
                    <div className='Memecoin_steps_rgtIconWrp'>
                      <div className='Memecoin_steps_rgtIconTop'>
                        <img className='Memecoin_steps_rgtIcon' src={new URL("../../../image/MemecoinNew/Memecoin_steps_rgtIcon1.webp", import.meta.url)} alt='' />
                      </div>
                      <div className='Memecoin_steps_rgtBtm'>
                        <h3>Concept Finalization</h3>
                        <p>
                          Collaborate with our team to finalize your idea and roadmap.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li
                    className={`Memecoin_steps_rgtItm`}
                  >
                    <div className='Memecoin_steps_rgtIconWrp'>
                      <div className='Memecoin_steps_rgtIconTop'>
                        <img className='Memecoin_steps_rgtIcon' src={new URL("../../../image/MemecoinNew/Memecoin_steps_rgtIcon2.webp", import.meta.url)} alt='' />
                      </div>
                      <div className='Memecoin_steps_rgtBtm'>
                        <h3>Token Development</h3>
                        <p>
                          Create a secure and functional token on the blockchain of your choice.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li
                    className={`Memecoin_steps_rgtItm`}
                  >
                    <div className='Memecoin_steps_rgtIconWrp'>
                      <div className='Memecoin_steps_rgtIconTop'>
                        <img className='Memecoin_steps_rgtIcon' src={new URL("../../../image/MemecoinNew/Memecoin_steps_rgtIcon3.webp", import.meta.url)} alt='' />
                      </div>
                      <div className='Memecoin_steps_rgtBtm'>
                        <h3>Smart Contract Deployment</h3>
                        <p>
                          Deploy and test the smart contract to ensure flawless performance.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li
                    className={`Memecoin_steps_rgtItm`}
                  >
                    <div className='Memecoin_steps_rgtIconWrp'>
                      <div className='Memecoin_steps_rgtIconTop'>
                        <img className='Memecoin_steps_rgtIcon' src={new URL("../../../image/MemecoinNew/Memecoin_steps_rgtIcon4.webp", import.meta.url)} alt='' />
                      </div>
                      <div className='Memecoin_steps_rgtBtm'>
                        <h3>Community Building</h3>
                        <p>
                          Develop strategies to attract and engage your audience.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li
                    className={`Memecoin_steps_rgtItm`}
                  >
                    <div className='Memecoin_steps_rgtIconWrp'>
                      <div className='Memecoin_steps_rgtIconTop'>
                        <img className='Memecoin_steps_rgtIcon' src={new URL("../../../image/MemecoinNew/Memecoin_steps_rgtIcon5.webp", import.meta.url)} alt='' />
                      </div>
                      <div className='Memecoin_steps_rgtBtm'>
                        <h3>Token Listing</h3>
                        <p>
                          Get your token listed on popular exchanges for wider reach.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li
                    className={`Memecoin_steps_rgtItm`}
                  >
                    <div className='Memecoin_steps_rgtIconWrp'>
                      <div className='Memecoin_steps_rgtIconTop'>
                        <img className='Memecoin_steps_rgtIcon' src={new URL("../../../image/MemecoinNew/Memecoin_steps_rgtIcon6.webp", import.meta.url)} alt='' />
                      </div>
                      <div className='Memecoin_steps_rgtBtm'>
                        <h3>Post-Launch Support</h3>
                        <p>
                          Continuous monitoring and updates to enhance performance and security.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </article>

        {/* Cost of Meme Coin Development */}

        <article className='Memecoin_cost_sct Memecoin_commn_sct'>
          <div className='Memecoin_cost_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_cost_wrp'>
              <div className='Memecoin_cost_lft'>
                <h2 className='Memecoin_common_title'>Cost of Meme Coin Development</h2>
                <p className='Memecoin_common_desp'>
                  The cost of meme coin development depends on various factors, including:
                </p>
              </div>

              <div className='Memecoin_cost_CntMain'>
                <div className='Memecoin_cost_CntLft'>
                  <div className="Memecoin_cost_itm">
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_cost_itm1.webp", import.meta.url)} alt='' />
                    <h3>Blockchain Platform</h3>
                    <p>The choice of blockchain significantly impacts development costs.</p>
                    <div className="Memecoin_cost_itmImgWrp">
                      <img className="Memecoin_cost_itmImg1" src={new URL("../../../image/MemecoinNew/Memecoin_cost_itmImg1.webp", import.meta.url)} alt='' />
                      <img className="Memecoin_cost_itmImg1Hvr" src={new URL("../../../image/MemecoinNew/Memecoin_cost_itmImg1Hvr.webp", import.meta.url)} alt='' />
                    </div>
                  </div>
                </div>
                <div className='Memecoin_cost_CntRgt'>
                  <div className="Memecoin_cost_itm">
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_cost_itm2.webp", import.meta.url)} alt='' />
                    <h3>Features and Customizations</h3>
                    <p>Advanced features and unique designs require additional resources.</p>
                  </div>
                  <div className="Memecoin_cost_itm">
                    <img src={new URL("../../../image/MemecoinNew/Memecoin_cost_itm3.webp", import.meta.url)} alt='' />
                    <h3>Marketing Efforts</h3>
                    <p>Comprehensive marketing campaigns add to the overall budget.</p>
                  </div>
                </div>
              </div>

              <p className="Memecoin_common_desp Memecoin_cost_btmDescp">
                As a reliable meme coin development company, we provide transparent pricing tailored to your project’s needs.
              </p>

            </div>
          </div>
        </article>

        {/* Revenue Factors of Meme Coin Development */}

        <article className='Memecoin_revenu_sct Memecoin_commn_sct'>
          <div className='Memecoin_revenu_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_revenu_wrp'>
              <div className='Memecoin_revenu_lft'>
                <h2 className='Memecoin_common_title'>Revenue Factors of Meme Coin Development</h2>
              </div>

              <div className='Memecoin_revenu_lst'>
                <div className="Memecoin_revenu_itm Memecoin_revenu_itmSml">
                  <div className="Memecoin_revenu_itmImg">
                    <img className="Memecoin_revenu_itmImgDefl" src={new URL("../../../image/MemecoinNew/Memecoin_revenu_itmImg1.webp", import.meta.url)} alt='' />
                    <img className="Memecoin_revenu_itmImgHvr" src={new URL("../../../image/MemecoinNew/Memecoin_revenu_itmImg1Hvr.webp", import.meta.url)} alt='' />
                  </div>
                  <h3>Integrate with NFT</h3>
                  <p>
                    Integrating and minting your meme coin as NFT (Non fungible token) on NFT marketplace platforms can earn a passive income.
                  </p>
                </div>
                <div className="Memecoin_revenu_itm Memecoin_revenu_itmLrg">
                  <div className="Memecoin_revenu_itmImg">
                    <img className="Memecoin_revenu_itmImgDefl" src={new URL("../../../image/MemecoinNew/Memecoin_revenu_itmImg2.webp", import.meta.url)} alt='' />
                    <img className="Memecoin_revenu_itmImgHvr" src={new URL("../../../image/MemecoinNew/Memecoin_revenu_itmImg2Hvr.webp", import.meta.url)} alt='' />
                  </div>
                  <h3>Integrate with NFT</h3>
                  <p>
                    Integrating and minting your meme coin as NFT (Non fungible token) on NFT marketplace platforms can earn a passive income.
                  </p>
                </div>
                <div className="Memecoin_revenu_itm Memecoin_revenu_itmLrg">
                  <div className="Memecoin_revenu_itmImg">
                    <img className="Memecoin_revenu_itmImgDefl" src={new URL("../../../image/MemecoinNew/Memecoin_revenu_itmImg3.webp", import.meta.url)} alt='' />
                    <img className="Memecoin_revenu_itmImgHvr" src={new URL("../../../image/MemecoinNew/Memecoin_revenu_itmImg3Hvr.webp", import.meta.url)} alt='' />
                  </div>
                  <h3>Integrate with NFT</h3>
                  <p>
                    Integrating and minting your meme coin as NFT (Non fungible token) on NFT marketplace platforms can earn a passive income.
                  </p>
                </div>
                <div className="Memecoin_revenu_itm Memecoin_revenu_itmSml">
                  <div className="Memecoin_revenu_itmImg">
                    <img className="Memecoin_revenu_itmImgDefl" src={new URL("../../../image/MemecoinNew/Memecoin_revenu_itmImg4.webp", import.meta.url)} alt='' />
                    <img className="Memecoin_revenu_itmImgHvr" src={new URL("../../../image/MemecoinNew/Memecoin_revenu_itmImg4Hvr.webp", import.meta.url)} alt='' />
                  </div>
                  <h3>Premium Services</h3>
                  <p>
                    Offer premium services within your Meme Coin ecosystem, creating additional revenue streams for advanced features and privileges.
                  </p>
                </div>

              </div>

            </div>
          </div>
        </article>

        {/* Contact Us Today */}

        <article className='Memecoin_contat_sct Memecoin_commn_sct'>
          <div className='Memecoin_contat_cont Memecoin_commn_cont primary__landing__container'>
            <div className='Memecoin_contat_wrp'>
              <div className='Memecoin_contat_lft'>
                <h2 className='Memecoin_common_title'>Contact Us Today</h2>
                <p className='Memecoin_common_desp'>
                  Ready to launch your own meme coin? Partner with the best meme coin
                  development company to turn your vision into reality.
                  Contact us today to get started on your journey to crypto success!
                </p>
                <button className='Memecoin_cmmn_Btn2'
                  data-toggle="modal"
                  data-target="#myModal"
                  aria-label="Get free consultation"
                >
                  <span className="MuiButton-label Memecoin_cmmn_Btn2Txt">Contact us</span>
                  <span className='Memecoin_cmmn_Btn2Arrw'>
                    <FiArrowUpRight className='Memecoin_cmmn_Btn2Arrw1' />
                    <FiArrowUpRight className='Memecoin_cmmn_Btn2Arrw2' />
                  </span>
                </button>
              </div>

              <div className="Memecoin_contat_rgt">
                <img src={new URL("../../../image/MemecoinNew/Memecoin_contat_rgtImg.webp", import.meta.url)} alt='' />
              </div>

            </div>
          </div>
        </article>


        <section className="bg-white">
          {/* faq */}
          <article className="primary__landing-content-container">
            <div className="landing-faq-wrapper">
              <div className="row">
                <div className="col-lg-6">
                  <h6 className="landing-faq-left-title">
                    Frequently Asked{" "}
                    <span className="faq-span">Questions.</span> {""}
                  </h6>
                </div>
                <div className="col-lg-6">
                  <div>
                    <div className="container">
                      <div className="accordion" id="faq">
                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead1">
                            <button
                              className="landing-faq-title collapsed"
                              type="button"
                              data-toggle="collapse"
                              data-target="#faq1"
                              aria-expanded="true"
                              aria-controls="faq1"
                            >
                              What is a meme coin?
                            </button>
                          </div>

                          <div
                            id="faq1"
                            className="collapse"
                            aria-labelledby="faqhead1"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              A meme coin is a cryptocurrency inspired by
                              internet memes and cultural trends, often
                              characterized by humor and community-driven
                              growth.
                            </div>
                          </div>
                        </div>

                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead2">
                            <div
                              className="landing-faq-title collapsed"
                              data-toggle="collapse"
                              data-target="#faq2"
                              aria-expanded="true"
                              aria-controls="faq2"
                            >
                              How long does it take to develop a meme coin?
                            </div>
                          </div>

                          <div
                            id="faq2"
                            className="collapse"
                            aria-labelledby="faqhead2"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              The development timeline depends on the complexity
                              of the project, typically ranging from 1 to 2
                              weeks.
                            </div>
                          </div>
                        </div>

                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead3">
                            <div
                              className="landing-faq-title collapsed"
                              data-toggle="collapse"
                              data-target="#faq3"
                              aria-expanded="true"
                              aria-controls="faq3"
                            >
                              Which blockchain is best for meme coin
                              development?
                            </div>
                          </div>

                          <div
                            id="faq3"
                            className="collapse"
                            aria-labelledby="faqhead3"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              Popular choices of blockchain include Ethereum,
                              Solana, Binance Smart Chain, and Polygon each
                              offering specific advantages.
                            </div>
                          </div>
                        </div>

                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead4">
                            <div
                              className="landing-faq-title collapsed"
                              data-toggle="collapse"
                              data-target="#faq4"
                              aria-expanded="true"
                              aria-controls="faq4"
                            >
                              Can you help with meme coin marketing?
                            </div>
                          </div>

                          <div
                            id="faq4"
                            className="collapse"
                            aria-labelledby="faqhead4"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              Yes, we provide comprehensive marketing services
                              to ensure your coin gains visibility and traction.
                            </div>
                          </div>
                        </div>

                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead5">
                            <div
                              className="landing-faq-title collapsed"
                              data-toggle="collapse"
                              data-target="#faq5"
                              aria-expanded="true"
                              aria-controls="faq5"
                            >
                              What is the cost of launching a meme coin?
                            </div>
                          </div>

                          <div
                            id="faq5"
                            className="collapse"
                            aria-labelledby="faqhead5"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              Costs vary based on the features, blockchain, and
                              marketing efforts involved. Contact us for a
                              customized quote.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </section>
        
      </main>
      {/* <Footer /> */}
      <ServiceFooter />
    </main>
  )
}

export default MemecoinNew